// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__-rML2","lastUpdated":"TermsOfService_lastUpdated__2nZ7Q"};